import { IconButtonProps } from '../../../icon-button/types';

const { appearance, size, transparent, ...props } = IconButtonProps;

export const DialogHeaderIconButtonProps = props;
